// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2sLhf","Heading":"Header_Heading__2aAmt","Logo":"Header_Logo__1AC1m"};